import React from "react";
import { Reveal } from "../../lib/motion";
import { useApp } from "@/context/AppContext";

export default function Ethos() {
  const { t } = useApp();
  return (
    <section id="ethos" data-testid="ethos-section" className="relative py-20 md:py-28">
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-[11px] tracking-[0.24em] uppercase text-black/75 mb-6 font-bold">
            {t("ethos.eyebrow")}
          </p>
          <h2 className="font-display font-black text-black leading-[0.98] tracking-[-0.02em] text-[clamp(2rem,5.4vw,4.75rem)]">
            {t("ethos.title1")}
            <br />
            <span className="text-black/55">{t("ethos.title2")}</span>
          </h2>
          <p className="mt-8 text-black/85 text-lg md:text-xl leading-relaxed max-w-3xl">
            {t("ethos.body")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
